<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/Flashback">Flashback: Snapshot of the Past</a></p>
<p class="toc1"><a href="#/Chapter01">1. Painting a Picture of Bygone Tea Rooms</a></p>
<p class="toc"><a href="#/Chapter02">2. A Look at the Historical Personality of the Tea Rooms and Locations</a></p>
<p class="toc"><span href="#/Chapter03" title="Link target outside of Sample">3. Times Changed</span></p>
<p class="toc"><span href="#/Chapter04" title="Link target outside of Sample">4. Beverages</span></p>
<p class="toc"><span href="#/Chapter05" title="Link target outside of Sample">5. Soups</span></p>
<p class="toc"><span href="#/Chapter06" title="Link target outside of Sample">6. Salads and Dressings</span></p>
<p class="toc"><span href="#/Chapter07" title="Link target outside of Sample">7. Sandwiches</span></p>
<p class="toc"><span href="#/Chapter08" title="Link target outside of Sample">8. Main Dishes</span></p>
<p class="toc"><span href="#/Chapter09" title="Link target outside of Sample">9. Accompaniments</span></p>
<p class="toc"><span href="#/Chapter10" title="Link target outside of Sample">10. Desserts</span></p>
<p class="toc1"><span href="#/Afterword" title="Link target outside of Sample">Afterword and Acknowledgements</span></p>
<p class="toc"><span href="#/Memories" title="Link target outside of Sample">Those Who Shared Memories</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?b0abc3a8